const nps = {
  nps: {
    npsBreakdown: 'Análise detalhada NPS',
    npsScore: 'Pontuação NPS',
    npsSpread: 'Dispersão NPS',
    npsDashboard: 'PAINEL NPS',
    npsDetails: 'Detalhes NPS',
    npsTrend: 'Tendência NPS',
    verbatims: 'Verbatins',
    timePeriod:  'Período de tempo: ',
    to: 'até',
    pastMonths: 'Últimos %{month} meses',
    ratingType: 'Tipo de classificação',
    systemId: 'ID do sistema',
    systemName: 'Nome do Sistema',
    rating: 'Nota',
    comments: 'Comentários',
    all: 'Todos',
    promoter: 'Promotor',
    promoters: 'Promotores',
    detractor: 'Detrator',
    detractors: 'Detratores',
    passive: 'Passivo',
    noData:  'Sem dados disponíveis',
    npsDashboardTooltip: {
      whatIs: 'O que é pontuação do promotor líquido?',
      npsDefine: "A pontuação do promotor líquido é um índice de -100 a 100 que mede a disposição dos clientes em recomendar uma empresa a terceiros. É usado como um proxy para medir a satisfação geral do cliente.",
      questionIs: `A pergunta é formulada como "Em uma escala de 0 a 10, qual a probabilidade de você recomendar nossa organização a um amigo ou colega?" Com base no número que um cliente escolhe, eles são classificados em uma das seguintes categorias`,
      determined: 'A Pontuação do promotor líquido (Net Promoter Score, NPS) é determinada subtraindo a porcentagem de clientes que são detratores da porcentagem que são promotores. O que é gerado é uma pontuação entre -100 e 100 chamada pontuação do promotor líquido.',
      how: 'Como o Enphase determina a NPS para você?',
      shownBelow:  'A Enphase solicita que os proprietários forneçam classificações no aplicativo Enlighten Mobile, conforme mostrado nas telas abaixo. Com base nas classificações fornecidas, a NPS é determinada conforme descrito acima.'
    },
    timePeriodTooltip: 'O período de tempo padrão passa de 13 meses. Se a pontuação NPS não estiver disponível nos últimos 13 meses, a pontuação será incluída a partir do primeiro mês disponível.',
    verbatimsTooltip: 'Todos os comentários mostrados aqui são de proprietários do sistema que deram consentimento para compartilhá-lo com as instaladoras.',
    jan: "Jan'",
    feb: "Fev'",
    mar: "Mar'",
    apr: "Abr'",
    may: "Mai'",
    jun: "Jun'",
    jul: "Jul'",
    aug: "Ago'",
    sep: "Set'",
    oct: "Out'",
    nov: "Nov'",
    dec: "Dez'",
    ofTotal: 'do total',
    ratings: 'Classificações',
    numberOfReviews: 'Número de avaliações',
    date: 'Data',
    between0And10: 'Digite um valor entre 0 e 10',
    lessThan50: 'O número de caracteres deve ser inferior a 50',
    npsBasedOnScore: `NPS de %{score} com base em %{count} classificações`
  }
};

export default nps;
